import React, { useEffect, useRef, useState } from 'react'
import { Link, useLocation } from "react-router-dom";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

import PartyEdit from './Party-Edit';
import AddresstList from '../../../../components/addressList';
import ContactList from '../../../../components/contactList';
import ManageNotification from '../notifications/ManageNotification';
import { getTrans as t } from "../../../../Localization/translations";
import PartyShortdetilview from './partyquickview';
import Partycontact from '../contact/Party-contact';
import ContactEdit from '../contact/ContactEdit';
import AddNotification from '../notifications/AddNotification';
import EditNotification from '../notifications/EditNotification';
import AchIndex from "../achAccount";
import AddAchAccounts from "../achAccount/achAdd";
import EditAchAccount from "../achAccount/achEdit";

function EditParty({ setCustomData, setNotesLength }) {
  const [tabIndex, setTabIndex] = useState(0);
  const [partytype, setPartyType] = useState('');
  const [object_name, setObject_name] = useState('Parties')
  const [hideShowParyContact, setHideShowParyContact] = useState(false)
  const [hideShowParyContactEdit, setHideShowParyContactEdit] = useState(false)
  const [hideShowNotify, setHideShowNotify] = useState(false)
  const [hideShowNotifyEdit, setHideShowNotifyEdit] = useState(false)
  const [contactId, setContactId] = useState('')
  const [notifyId, setNotifyId] = useState('')
  const [email_invoice_notification_count, setEmail_invoice_notification_count] = useState("")

  const [hideShowachindex, setHideShowAchIndex] = useState(false);
  const [hideShowachedit, setHideShowAchEdit] = useState(false);
  const [hideShowachId, setHideShowAchID] = useState("");

  const addfromAch = useRef(null);
  const editformAch = useRef(null);
  const [achId, setACHId] = useState(null);

  const { state } = useLocation();
  useEffect(() => {
    setCustomData({
      object_id :state,
      object_name:object_name
    })
  }, [object_name,setCustomData,state])

  const addFormRef = useRef(null);
  const editFormRef = useRef(null);
  const addfromcontract = useRef(null)
  const editformcontract = useRef(null)

  useEffect(() => {
    if (hideShowNotify && addFormRef.current) {
      addFormRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [hideShowNotify]);

  useEffect(() => {
    if (hideShowParyContact && addfromcontract.current) {
      addfromcontract.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [hideShowParyContact]);

  useEffect(() => {
    if (hideShowParyContactEdit && editformcontract.current) {
      editformcontract.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [hideShowParyContactEdit]);

  useEffect(() => {
    if (hideShowNotifyEdit && editFormRef.current) {
      editFormRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  }, [hideShowNotifyEdit]);
  return (
    <>
      <div className="container-fluid py-4">
        <div className="form-group row">
          <div className="col-md-12">
            <div className="header pb-0 mb-3">
              <h5>{t("Edit Party")}</h5>
              <h6><Link to="/party" className='tc'>{t("Parties")}</Link> / <span>{t("Edit Party")}</span>  </h6>
            </div>
            <Tabs selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index)}>
              <TabList>
                <Tab>
                  <p>{t("Party Detail")}</p>
                </Tab>
                {partytype.includes("Customer") ? (
                                  // achPayments === true ?
                    <> 
                      <Tab>
                        <p>{t("Bank Accounts")}</p>
                      </Tab>
                      </>
                    
                  ) : 
                    ""
                  }
                <Tab>
                  <p>{t("Address Details")}</p>
                </Tab>
                <Tab>
                  <p>{t("Contact Details")}</p>
                </Tab>
                {
                  partytype.includes("Customer")?
                    <Tab>
                      <p>{t("Notification Settings")}</p>
                    </Tab>:
                    ""
                }
              </TabList>

              <TabPanel>
                <div className="panel-content ">
                  <PartyEdit partyType={setPartyType} setNotesLength={setNotesLength} setEmail_invoice_notification_count={setEmail_invoice_notification_count} email_invoice_notification_count={email_invoice_notification_count}/>
                </div>
              </TabPanel>
              {partytype.includes("Customer") ? (
                                // achPayments === true ?
                                <> 
                            <TabPanel>
                              <div
                                className="panel-content pa-co"
                                style={{ paddingLeft: "10px" }}
                              >
                                {/* <ContractList id={state} /> */}
                                {/* <div className='pt-4'> */}
              
                                <AchIndex
                                  id={state}
                                  setHideShowAchIndex={setHideShowAchIndex}
                                  setHideShowAchEdit={setHideShowAchEdit}
                                  hideShowachindex={hideShowachindex}
                                  hideShowachedit={hideShowachedit}
                                  setHideShowAchID={setHideShowAchID}
                                />
                                {/* </div> */}
                                {hideShowachindex && (
                                  <div className="pt-4" ref={addfromAch}>
                                    <AddAchAccounts
                                      id={state}
                                      setHideShowAchIndex={setHideShowAchIndex}
                                      setACHId={setACHId}
                                    />
                                  </div>
                                )}
                                {hideShowachedit && (
                                  <div className="pt-4" ref={editformAch}>
                                    <EditAchAccount
                                      id={state}
                                      hideShowachId={hideShowachId}
                                      setHideShowAchEdit={setHideShowAchEdit}
                                    />
                                  </div>
                                )}
                              </div>
                            </TabPanel>
                            </>
                              )
                            :""
                              }
              <TabPanel>
                <div className="panel-content pa-co" style={{ paddingLeft: "10px" }}>
                  <PartyShortdetilview id={state}/>
                  <div className='pt-4'>
                    <AddresstList id={state} />
                  </div>
                </div>
              </TabPanel>
              <TabPanel>
                <div className="panel-content pa-co" style={{ paddingLeft: "10px" }}>
                  <PartyShortdetilview id={state}/>
                  <div className='pt-4'>
                    <ContactList id={state} setHideShowParyContact={setHideShowParyContact} setHideShowParyContactEdit={setHideShowParyContactEdit} setContactId={setContactId} hideShowParyContact={hideShowParyContact} hideShowParyContactEdit={hideShowParyContactEdit} />
                  </div>
                  {hideShowParyContact &&
                    <div className='pt-4' ref={addfromcontract}>
                      <Partycontact id={state} setHideShowParyContact={setHideShowParyContact}/>
                    </div>
                  }
                  {hideShowParyContactEdit && contactId &&
                    <div className='pt-4' ref={editformcontract}>
                      <ContactEdit id={state} contact={contactId} setHideShowParyContactEdit={setHideShowParyContactEdit}/>
                    </div>
                  }
                </div>
              </TabPanel>
              <TabPanel>
                <div className="panel-content pa-co" style={{ paddingLeft: "10px" }}>
                  <PartyShortdetilview id={state}/>
                  <div className='pt-4'>
                    <ManageNotification id={state} setHideShowNotify={setHideShowNotify} setHideShowNotifyEdit={setHideShowNotifyEdit} hideShowNotify={hideShowNotify} hideShowNotifyEdit={hideShowNotifyEdit} setNotifyId={setNotifyId} />
                  </div>
                  {hideShowNotify &&
                    <div className='pt-4'ref={addFormRef}>
                      <AddNotification id={state} setHideShowNotify={setHideShowNotify} email_invoice_notification_count={email_invoice_notification_count}/>
                    </div>
                  }
                  {
                    hideShowNotifyEdit &&
                    <div className='pt-4' ref={editFormRef}>
                      <EditNotification id={state} notification={notifyId} setHideShowNotifyEdit={setHideShowNotifyEdit} email_invoice_notification_count={email_invoice_notification_count}/>
                    </div>
                  }
                </div>
              </TabPanel>
            </Tabs>

          </div>
        </div>
        <div className="col-md-10">
        </div>
      </div>

    </>
  )
}

export default EditParty
